/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbTeamSummary } from './HchbTeamSummary';
import {
    HchbTeamSummaryFromJSON,
    HchbTeamSummaryFromJSONTyped,
    HchbTeamSummaryToJSON,
    HchbTeamSummaryToJSONTyped,
} from './HchbTeamSummary';

/**
 * 
 * @export
 * @interface HchbBranchSummary
 */
export interface HchbBranchSummary {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    service_line: string;
    /**
     * 
     */
    external_id?: string;
    /**
     * 
     */
    teams?: Array<HchbTeamSummary>;
}

/**
 * Check if a given object implements the HchbBranchSummary interface.
 */
export function instanceOfHchbBranchSummary(value: object): value is HchbBranchSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('service_line' in value) || value['service_line'] === undefined) return false;
    return true;
}

export function HchbBranchSummaryFromJSON(json: any): HchbBranchSummary {
    return HchbBranchSummaryFromJSONTyped(json, false);
}

export function HchbBranchSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbBranchSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'service_line': json['service_line'],
        'external_id': json['external_id'] == null ? undefined : json['external_id'],
        'teams': json['teams'] == null ? undefined : ((json['teams'] as Array<any>).map(HchbTeamSummaryFromJSON)),
    };
}

export function HchbBranchSummaryToJSON(json: any): HchbBranchSummary {
    return HchbBranchSummaryToJSONTyped(json, false);
}

export function HchbBranchSummaryToJSONTyped(value?: HchbBranchSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'service_line': value['service_line'],
        'external_id': value['external_id'],
        'teams': value['teams'] == null ? undefined : ((value['teams'] as Array<any>).map(HchbTeamSummaryToJSON)),
    };
}

